import axios from 'axios';
import {
    USERS_API,
    API_HEADER
} from '../../../constants/API'
import {
    ADD_STRIPE_ACCOUNT_WITH_PLAID_LOADING,
} from '../types';
import { message } from 'antd';

export default (data) => {
    return async (dispatch, getState) => {
        try {
            const { token } = getState().UserReducer;
            dispatch({
                type: ADD_STRIPE_ACCOUNT_WITH_PLAID_LOADING,
                loadingStripeAccountWithPlaidLoading: true
            });
            await axios.post(`${USERS_API}/stripe/plaid`, data, API_HEADER(token));
            dispatch({
                type: ADD_STRIPE_ACCOUNT_WITH_PLAID_LOADING,
                loadingStripeAccountWithPlaidLoading: false
            });
            window.location.reload()

        } catch (e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }
            dispatch({
                type: ADD_STRIPE_ACCOUNT_WITH_PLAID_LOADING,
                loadingStripeAccountWithPlaidLoading: false
            });
        }
    }
}